<template>
  <div>

    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-row>
        <span class="mb-3">
          {{ $t('reportes') }}</span>
      </b-row>
    </base-header>

    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-form-group label-for="empresa">
            <label> {{ $t('material') }}</label>
            <el-select class="custom-input" v-model="material" filterable clearable :placeholder="$t('todo')"
              style="width: 100%;">
              <el-option v-for="item in materialesOptions" :key="item.value" :label="item.text" :value="item.value" />
            </el-select>
          </b-form-group>
        </b-col>

        <b-col v-if="rol === 'admin'">
          <b-form-group label-for="empresa">
            <label> {{ $t('cliente') }}</label>
            <el-select class="custom-input" v-model="empresa" filterable clearable :placeholder="$t('todo')"
              style="width: 100%;">
              <el-option v-for="item in empresasOptions" :key="item.value" :label="item.text" :value="item.value" />
            </el-select>
          </b-form-group>
        </b-col>

        <b-col>
          <label> {{ $t('fecha_inicio') }}</label>
          <b-form-input v-model="fechaInicio" type="date" placeholder="dd-mm-aaaa" class="mb-2"></b-form-input>
        </b-col>

        <b-col>
          <label> {{ $t('fecha_fin') }}</label>
          <b-form-input v-model="fechaFin" type="date" placeholder="dd-mm-aaaa" class="mb-2"></b-form-input>
        </b-col>

        <b-col class="d-flex align-items-center mt-2">
          <b-button variant="info" @click="filterMaterialesGraficos">{{ $t('filtrar') }}</b-button>
          <b-button variant="primary" @click="exportMaterial">{{ $t('exportar') }}</b-button>
        </b-col>
      </b-row>

      <b-row v-if="dashboardHistBanner != null && dashboardHistBanner.pesoAcumulado"
        class="d-flex flex-wrap justify-content-center mb-3 mt-6" xl="6">
        <b-col xl="12" class="mb-5 mb-xl-0">
          <b-row class="p-0">

            <div class=" mb-xl-0 col-xl-4">
              <stats-card title="Total Materiales por Kilos" type="gradient-custom"
                :sub-title="(dashboardHistBanner && dashboardHistBanner.pesoAcumulado.length > 0 ? dashboardHistBanner.pesoAcumulado[0].total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : '0') + ' Kg'"
                icon="ni ni-chart-bar-32" class="mb-4 ">
              </stats-card>
            </div>

            <div class=" mb-xl-0 col-xl-4">
              <stats-card title="Total Monto Ingresos" type="gradient-custom"
                :sub-title="(dashboardHistBanner && dashboardHistBanner.ingresosNoPagados.length > 0 ? dashboardHistBanner.ingresosNoPagados[0].total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '' : '0') + ' CLP'"
                icon="ni ni-money-coins" class="mb-4">
              </stats-card>
            </div>

            <div class=" mb-xl-0 col-xl-4">
              <stats-card title="Mayor Material x Tonelaje" type="gradient-custom"
                :sub-title="(dashboardHistBanner && dashboardHistBanner.mayorPeso.length > 0 ? (dashboardHistBanner.mayorPeso[0].nombre ? (dashboardHistBanner.mayorPeso[0].nombre + ': ') : 'No data') + dashboardHistBanner.mayorPeso[0].total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' Kg' : '0')"
                icon="ni ni-chart-pie-35" class="mb-4">
              </stats-card>
            </div>

          </b-row>
        </b-col>
      </b-row>

      <b-row class="mb-3 mt-3">
        <!-- Bar Chart Horizontal-->
        <b-col xl="12" class="mb-5 mb-xl-0">
          <card header-classes="bg-transparent">
            <h5 class="text-uppercase ls-1 mb-1 mt-4">{{ $t('distribucion_tonelaje') }} {{ $t('por') }}:</h5>
            <h4 class="text-uppercase mb-1 mt-3">{{ $t('material') }}</h4>
            <BarChart :chart-data="barChartData" :chart-options="barChartOptions" style="height: 500px;" class="mb-4" />
          </card>
        </b-col>

        <!-- Bar Chart Vertical -->
        <b-col xl="12" class="mb-5 mt-6 mb-xl-0">
          <card header-classes="bg-transparent">
            <h5 class="text-uppercase ls-1 mb-1 mt-4">{{ $t('distribucion_tonelaje_neto') }} {{ $t('por') }} {{
              $t('precio') }} (CLP):</h5>
            <h4 class="text-uppercase mb-1 mt-3">{{ $t('material') }}</h4>
            <BarChart :chart-data="barChartData2" :chart-options="barChartOptions2" style="height: 500px;" />
          </card>
        </b-col>
      </b-row>

      <!-- Segment Chart  -->
      <b-row class="mb-3 mt-6">
        <b-col xl="12">
          <card header-classes="bg-transparent">
            <b-col>
              <h6 class="text-light text-uppercase ls-1 mb-1">{{ $t('materiales') }}</h6>
              <h4 class="text-uppercase ls-1 mb-1 mt-3">{{ $t('material_seis_meses') }}</h4>
            </b-col>
            <GroupedBarChart :chart-data="segmentChartData" :chart-options="segmentChartOptions"
              style="height: 500px;" />
          </card>
        </b-col>
      </b-row>
      <!-- linechart-->
      <b-row class="mb-3 mt-6">
        <b-col xl="12">
          <card header-classes="bg-transparent">
            <b-col>
              <h4 class="text-uppercase ls-1 mb-1 mt-3">{{ $t('chofer_viajes') }}</h4>
              <line-chart :chart-data="lineChartData" :chart-options="lineChartOptions"
                style="height: 500px;"></line-chart>
            </b-col>
          </card>
        </b-col>
      </b-row>

      <b-row class="mb-3 mt-6 ">
        <b-col xl="12" class="mb-0 mb-xl-0 ">
          <card type="default" header-classes="bg-transparent"
            style="background-color: #feffff !important; color: red !important;">
            <b-row class="mb-4 mt-3">
              <b-col>
                <b-form-group label-for="empresa">
                  <label class="text-dark">{{ $t('estado_pago') }}</label>
                  <el-select class="custom-input" v-model="estadoPago" filterable clearable :placeholder="$t('todo')"
                    style="width: 100%;">
                    <el-option v-for="item in estadoPagoOptions" :key="item.value" :label="item.text"
                      :value="item.value" />
                  </el-select>
                </b-form-group>
              </b-col>

              <b-col v-if="rol === 'admin'">
                <b-form-group label-for="empresa">
                  <label class="text-dark">{{ $t('empresa') }}</label>
                  <el-select class="custom-input" v-model="empresa" filterable clearable :placeholder="$t('todo')"
                    style="width: 100%;">
                    <el-option v-for="item in empresasOptions" :key="item.value" :label="item.text"
                      :value="item.value" />
                  </el-select>
                </b-form-group>
              </b-col>
              <b-col class="d-flex align-items-center mt-2">
                <b-button variant="primary" @click="exportEstadoPago">{{ $t('exportar') }}</b-button>
              </b-col>
            </b-row>

            <div class="flex-wrap ">
              <b-row slot="header"
                class="text-uppercase text-muted ls-1 mb-2 justify-content-center align-items-center">
                <h4>{{ $t('total_clp_por_estado_pago') }}</h4>
              </b-row>
              <b-row>
                <b-col v-for="(estado, index) in dataPagos" :key="index"
                  class="estado-pago-card mb-4 mb-5 mb-xl-0 col-xl-6">
                  <router-link v-if="rol === 'admin'" :to="`/ingresos/pagados/4/${estado.id}`">
                    <h3>{{ estado.estadoPago }}</h3>
                  </router-link>
                  <h3 v-else>{{ estado.estadoPago }}</h3>
                  <table>
                    <thead>
                      <tr>
                        <th>{{ $t('Empresa') }}</th>
                        <th>{{ $t('Material') }}</th>
                        <th style="padding-right: 20px;text-align: center;">Total (Ton)</th>
                        <th></th>
                        <th style="text-align: center;">Total (Clp)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(material, i) in estado.materiales" :key="i">
                        <td v-if="i == 0">{{ estado.empresa }}</td>
                        <td v-else></td>
                        <td>{{ material.material }}</td>
                        <td style="padding-right: 20px; text-align: center;">{{ material.totalTon.toFixed(2) }}</td>
                        <td></td>
                        <td style="text-align: center;">{{ formatNumber(material.total) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>
            </div>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { Pie, Bar, Line } from 'vue-chartjs';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  ArcElement,
  BarElement,
} from 'chart.js';
import dashboardService from '@/api/dashboardService';
import miscService from '@/api/miscService';
import pagoService from '@/api/pagoService';
import utilsService from '@/api/utilsService';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import materialService from '@/api/materialService';
import { Select, Option } from 'element-ui';
ChartJS.register(ChartDataLabels);

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  ArcElement,
  BarElement,
  LinearScale
);

export default {
  name: 'Dashboard',
  components: {
    PieChart: Pie,
    BarChart: Bar,
    GroupedBarChart: Bar,
    [Select.name]: Select,
    [Option.name]: Option,
    LineChart: Line,
  },
  data() {
    return {
      material: null,
      empresa: null,
      estadoPago: null,
      fechaInicio: null,
      fechaFin: null,
      materialesOptions: [],
      estadoPagoOptions: [],
      empresasOptions: [],
      dashboardHistBanner: {},
      choferesData: [],
      dataPagos: [],
      camionesData: [],
      lengthColors: 10,
      barChartData: { labels: [], datasets: [] },
      barChartData2: { labels: [], datasets: [] },
      pieChartData: { labels: [], datasets: [] },
      lineChartData: { labels: [], datasets: [] },
      segmentChartData: { labels: [], datasets: [] },
      segmentChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            stacked: false,
            ticks: {
              color: '#000'
            }
          },
          y: {
            ticks: {
              color: '#000'
            }
          }
        },
        plugins: {
          datalabels: {
            display: false,

          },
        }
      },
      barChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        spectRatio: 0.5,
        indexAxis: 'y',
        scales: {
          x: {
            ticks: {
              color: '#000'
            }
          },
          y: {
            ticks: {
              color: '#000'
            }
          }
        },
        plugins: {
          legend: {
            display: false
          }, 
          tooltip: {
            enabled: true,
            callbacks: {
              label: (context) => {
                const value = context.raw; 
                return this.formatNumber(value) + ' TON'; 
              }
            }
          },
          datalabels: {
            display: true,
            color: '#5ba3c5',
            anchor: 'end',
            align: 'right',
            font: {
              size: 12,
            }, 
            formatter: (value) => {
              return this.formatNumber(value); 
            }
          },
        }
      },
      barChartOptions2: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              color: '#000'
            },
            max: function (context) {
              const maxData = Math.max(...context.chart.data.datasets[0].data);
              const magnitude = Math.pow(10, Math.floor(Math.log10(maxData))); 
              const roundedMax = Math.ceil(maxData / magnitude) * magnitude; 
              return roundedMax + magnitude; 
            }
          },
          x: {
            ticks: {
              color: '#000'
            }
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: (context) => {
                const value = context.raw; 
                return this.formatNumber(value) + ' CLP'; 
              }
            }
          },
          datalabels: {
            display: true,
            color: '#5ba3c5',
            anchor: 'end',
            align: 'top',
            font: {
              size: 12,
            },
            formatter: (value) => {
              return this.formatNumber(value); 
            }
          },
        }
      },
      lineChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'top',
          },
          title: {
            display: true,
            text: 'Cantidad de Viajes por Mes',
          },
          datalabels: {
            display: true,
            color: 'blue',
            anchor: 'end',
            align: 'top',
            font: {
              size: 12,
            },
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Meses',
            },
          },
          y: {
            title: {
              display: true,
              text: 'Cantidad de Viajes',
            },
            beginAtZero: true,
          },
        },
      },
      colors: []
    };
  },
  async mounted() {
    this.fechaInicio = new Date(new Date().getFullYear(), 0, 1).toISOString().split('T')[0];
    this.fechaFin = new Date(new Date().getFullYear(), 11, 31).toISOString().split('T')[0];
    this.estadoPagoOptions = await miscService.getEstadoPagosOptions();
    const materialesLastSixMonths = await dashboardService.getMaterialesLastSixMonth();
    this.lengthColors = materialesLastSixMonths.materiales ? materialesLastSixMonths.materiales.length : 50;
    this.choferesData = await dashboardService.getChoferesMeses(this.fechaInicio, this.fechaFin);
    //this.camionesData = await dashboardService.getCamionEmpresa();
    this.materialesOptions = await miscService.getMaterialesOptions();
    if (this.rol === 'admin') this.empresasOptions = await miscService.getEmpresasOptions();
    this.dataPagos = await dashboardService.getMaterialesByPago();
    this.dashboardHistBanner = await dashboardService.getDataBanner(this.fechaInicio, this.fechaFin, 0);
    let materialesResponse = [];

    try {
      materialesResponse = await dashboardService.getDataMaterialGraficos(this.fechaInicio, this.fechaFin, 0, 0);
    } catch {
      console.log("error el cargar los graficos");
    }

    await this.InitGraficos(materialesResponse);
    // Segment Chart Data 
    this.segmentChartData = {
      labels: materialesLastSixMonths.meses,
      datasets: materialesLastSixMonths.materiales.map((material, index) => ({
        label: material.nombre,
        data: material.tonelajes,
        backgroundColor: this.colors[index % this.colors.length],
        borderRadius: 10
      }))
    };
  },
  computed: {
    rol() {
      return utilsService.getRol();
    }
  },
  methods: {
    async InitGraficos(materialesResponse) {
      const meses = this.choferesData.map((data) => data.mes);
      const cantidadViajes = this.choferesData.map((data) => data.cantidadViajes);
      this.lineChartData = {
        labels: meses,
        datasets: [
          {
            label: 'Cantidad de Viajes',
            data: cantidadViajes,
            borderColor: 'blue',
            backgroundColor: 'rgba(0, 123, 255, 0.5)',
            tension: 0.4,
          },
        ],
      };
      this.colors = this.generateColors(this.lengthColors);

      const data = materialesResponse.map((item) => ({
        label: item.nombre,
        peso: parseFloat(item.peso)
      }));
      this.barChartData = {
        labels: data.map((item) => item.label),
        datasets: [
          {
            data: data.map((item) => item.peso),
            backgroundColor: this.colors,
            borderRadius: 10
          }
        ]
      };

      const data2 = materialesResponse.map((item) => ({
        label: item.nombre,
        precio: parseInt(item.precioTotal)
      }));
      this.barChartData2 = {
        labels: data2.map((item) => item.label),
        datasets: [
          {
            data: data2.map((item) => item.precio),
            backgroundColor: this.colors,
            borderRadius: 10
          }
        ]
      };

      this.barChartOptions2.scales.x.ticks = {
        callback: (value, index) => {
          const label = this.barChartData2.labels[index];
          return label;
        },
        color: '#000'
      };

    },
    formatNumber(value) {
      return new Intl.NumberFormat('es-CL').format(value);
    },
    generateColors(count) {
      // Reemplaza esta lista con los colores de tu paleta 
      const corporateColors = ["#9ecae2", "#4292c6", "#abcdef", "#0a1e5c", "#789abc", "#07306b", "#2271b5"];
      const colors = [];
      for (let i = 0; i < count; i++) {
        colors.push(corporateColors[i % corporateColors.length]);
      }
      return colors;
    },
    async exportMaterial() {
      try {
        const material = this.material || 0;
        const empresa = this.empresa || 0;
        Swal.fire({
          html: `
                <div style="display: flex; align-items: center; justify-content: center;"> 
                  <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                  <div>
                    <h3 style="color: #006393;">Generando reporte...</h3>
                  </div>
                </div>`,
          showConfirmButton: false,
          allowOutsideClick: false
        });
        await materialService.getMaterialReporte(this.fechaInicio, this.fechaFin, material, empresa);
        Swal.close();

      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error
        });
        return;
      }
    },
    async exportEstadoPago() {
      try {

        const estadoPago = this.estadoPago || 0;
        const empresa = this.empresa || 0;
        if (estadoPago == 0) {
          this.$toast.error('El Estado de Pago es requerido.', {
            position: 'top-center',
            timeout: 2000,
            closeOnClick: true,
            pauseOnHover: true
          });

          return;
        }
        Swal.fire({
          html: `
                <div style="display: flex; align-items: center; justify-content: center;"> 
                  <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                  <div>
                    <h3 style="color: #006393;">Generando reporte...</h3>
                  </div>
                </div>`,
          showConfirmButton: false,
          allowOutsideClick: false
        });
        await pagoService.getReporteEstadoPago(estadoPago, empresa);
        Swal.close();

      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error
        });

        return;
      }
    },
    async filterMaterialesGraficos() {
      try {
        const material = this.material || 0;
        const empresa = this.empresa || 0;
        Swal.fire({
          html: `
                <div style="display: flex; align-items: center; justify-content: center;"> 
                  <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                  <div>
                    <h3 style="color: #006393;">Cargando...</h3>
                  </div>
                </div>`,
          showConfirmButton: false,
          allowOutsideClick: false
        });
        const materialesResponse = await dashboardService.getDataMaterialGraficos(this.fechaInicio, this.fechaFin, material, empresa);
        this.dashboardHistBanner = await dashboardService.getDataBanner(this.fechaInicio, this.fechaFin, material);
        this.choferesData = await dashboardService.getChoferesMeses(this.fechaInicio, this.fechaFin);
        await this.InitGraficos(materialesResponse);
        Swal.close();

      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error
        });
        return;
      }
    }
  }
};
</script>

<style scoped>
.materiales span {
  float: left;
  margin-top: 6px;
  margin-right: 7px;
}

li::marker {
  content: none;
}

.container {
  margin-top: 20px;
}

.d-flex {
  display: flex;
  flex-wrap: wrap;
}

.estado-pago-card {
  margin: 10px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
  font-size: 0.8rem;
}

h3 {
  margin-bottom: 10px;
  color: #007acc;
}

table {
  width: 100%;
  border-collapse: collapse;
  color: #4d4c4c;
}

th {
  background-color: #e6e6e6;
  font-weight: bold;
  text-align: left;
}

td {
  text-align: left;
}

tr:nth-child(even) {
  background-color: #e6e6e6;
}

.table-mini {
  width: 100%;
  border-collapse: collapse;
  color: #4d4c4c;
  background-color: #ffffff !important;
  margin-top: 10px;
  border: 1px solid #ddd;
}

.table-mini th {
  background-color: #f0f0f0;
  font-weight: bold;
  text-align: left;
  border: 1px solid #ddd;
  padding: 8px;
}

.table-mini td {
  text-align: left;
  border: 1px solid #ddd;
  padding: 8px;
}

.table-mini tr:nth-child(even) {
  background-color: #ececec;
}

.table-mini tr:nth-child(odd) {
  background-color: #ffffff;
}

.tabla-mini {
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #ffffff;
}

.card.card-stats.mb-4 {
  height: 142px !important;
}

p.mt-3.mb-0.text-sm {
  bottom: 5px;
  position: absolute;
}

.tt-c {
  text-transform: uppercase;
}

@media (min-width: 1200px) {
  .col-xl-6 {
    max-width: 48%;
  }
}

.card-header h4 {
  font-size: 0.8rem;
}

card-header {
  padding: 1.25rem 1.5rem 0;
}

.card-body {
  padding: 0 1.5rem;
  font-size: 0.8rem !important;
}

table.table-mini.tt-c {
  font-size: 0.8rem;
}
</style>
